/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidacyCvStorePathParams,
	CandidacyCvStoreRequest,
	CandidacyCvStoreResponse,
} from '../types/CandidacyCvStore'
import { buildFormData } from '../utils/form-data'

/**
 * POST /candidate-center/organisations/:organisation/candidacies/:candidacy/cv
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyCvController.php CandidacyCvController::store
 */
export async function candidacyCvStore(
	organisation: CandidacyCvStorePathParams['organisation'],
	candidacy: CandidacyCvStorePathParams['candidacy'],
	data: CandidacyCvStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyCvStoreResponse>> {
	return axiosInstance.post(
		`/candidate-center/organisations/${organisation}/candidacies/${candidacy}/cv`,
		buildFormData(data),
		{ headers: { 'Content-Type': 'multipart/form-data' }, ...config },
	)
}
